import { onUnmounted } from '@vue/composition-api';

export default function useActiveImageByMouse(container, images, activeImageIndex) {
    const calcActiveImage = (event) => {
        const target = event.target;

        if (target.closest('.l-ss-c-offer-image-indicators')) {
            const imgIndex = +target.dataset.index || 0;
            activeImageIndex.value = imgIndex;
            return;
        }

        const rect = container.getBoundingClientRect();
        const containerWidth = rect.width;
        const mouseX = event.clientX - rect.left;
        const sectorWidth = containerWidth / images.length;

        let imgIndex = Math.floor(mouseX / sectorWidth);

        if (imgIndex < 0) {
            imgIndex = 0;
        } else if (imgIndex > images.length - 1) {
            imgIndex = images.length - 1;
        }

        activeImageIndex.value = imgIndex;
    };

    const resetActiveImage = (event) => {
        const target = event.target;

        if (target.closest('.l-ss-c-offer-image-indicators')) {
            return;
        }

        activeImageIndex.value = 0;
    };

    onUnmounted(() => {
        container.removeEventListener('mousemove', calcActiveImage);
        container.removeEventListener('mouseleave', resetActiveImage);
    });

    container.addEventListener('mousemove', calcActiveImage);
    container.addEventListener('mouseleave', resetActiveImage);
}
